import {
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  PARTNER_INFO_REQUEST,
  PARTNER_INFO_SUCCESS,
  PARTNER_INFO_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  isLoading: false,
  isLoadingPartner: false,
  error: null,
  accessToken: null,
  partnerInfo:null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_REQUEST:
      return { ...state, isLoading: true, error: null };
    case AUTH_SUCCESS:
      return { ...state, isLoading: false, accessToken: action.payload };
    case AUTH_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case PARTNER_INFO_REQUEST:
      return { ...state, isLoadingPartner: true, error: null };
    case PARTNER_INFO_SUCCESS:
      return { ...state, isLoadingPartner: false, partnerInfo: action.payload };
    case PARTNER_INFO_FAILURE:
      return { ...state, isLoadingPartner: false, error: action.payload };
    default:
      return state;
  }
};

export default authReducer;
